import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../store/types';

export const useStoreDispatch: () => AppDispatch = useDispatch
export const useStoreSelector: TypedUseSelectorHook<RootState> = useSelector;